import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(() => {
  const fp = { models: {} };
  return { provide: { fp } };
});
